export default (form, objValidated) => {
  Object.keys(form).forEach(e => {
    form[e] = null
  })
}
